<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#F9F9F9"
        fixed
        nav
        elevation="0"
        app>
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="body-2 font-weight-bold black--text text-capitalize d-flex align-center"
          :class="clipped ? 'pl-16 ml-2' : ''">
          <span
            style="opacity: 40%;">
            {{ Object.keys(company).length > 0 ? company.company_name : 'PT Amanata' }}
          </span>

          <v-icon size="20" class="mx-2" color="#959595">mdi-chevron-double-right</v-icon>

          <span
            class="black--text">
            {{ $route.name }}
          </span>
        </v-toolbar-title>

        <v-spacer/>

        <v-menu
          close-on-content-click 
          nudge-width="250" 
          offset-x>
          <template v-slot:activator="{ on }">
            <div v-on="on" 
              class="cursor-pointer">
              <v-badge v-if="total > 0"
                color="red"
                overlap>
                <span v-if="total > 9"
                  slot="badge">
                  9+
                </span>

                <span slot="badge" v-else>
                  {{ total }}
                </span>
                
                <span slot="default">
                  <v-icon color="orange">mdi-bell</v-icon>
                </span>
              </v-badge>

              <span v-else
                slot="default">
                <v-icon color="grey">mdi-bell</v-icon>
              </span>
            </div>
          </template>
        </v-menu>

        <v-text-field
          class="no_box ml-4"
          solo
          color="#388E3C"
          placeholder="Cari"
          
          hide-details
          
          style="max-width: 300px">
        </v-text-field>

        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              class="ml-4"
              color="transparent">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 10px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="30"
                  tile
                  style="border-radius: 5px !important;">
                  <v-img 
                    width="100%"
                    height="auto"
                    alt="umb" 
                    :src="user.image_url === '' ? require('@/assets/image/member_default.jpg') : user.image_url"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          color="#388E3C">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="clipped"
        width="275"
        color="#F9F9F9"
        dark
        fixed
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1 mb-6"
          style="height: 64px;">
          <div
            class="d-flex align-center">
            <!-- <v-img 
              contain
              :width="!clipped ? 36 : 30"
              :height="!clipped ? 36 : 30"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    color="#388E3C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div v-if="!clipped"
              class="text-h5 font-weight-bold text-center one-line color-default ml-2">
              {{ Object.keys(company).length > 0 ? company.company_name : 'amanata' }}
            </div>

            <v-spacer />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                color="black">
                mdi-chevron-left
              </v-icon>
            </v-btn> -->

            <v-img v-if="clipped"
              contain
              width="30"
              height="30"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    color="#388E3C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-img v-if="!clipped"
              contain
              width="100"
              height="auto"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    color="#388E3C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                color="black">
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-list>
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent">
              <v-list-item-avatar
                size="22"
                tile
                class="mr-4">
                <v-icon
                  size="22"
                  :color="item.link === $route.fullPath ? '#388E3C' : '#959595'">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="item.link === $route.fullPath ? 'color-default font-weight-bold' : 'color-grey'">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-else
              v-model="item.active"
              color="#388E3C"
              :append-icon="item.sub_menu.length > 0 ? 'mdi-menu-down' : ''"
              no-action>
              <template v-slot:activator>
                <v-list-item-avatar
                  size="22"
                  tile
                  class="mr-4">
                  <v-icon
                    size="22"
                    :color="item.active ? '#388E3C' : '#959595'">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item.active ? 'color-default font-weight-bold' : 'color-grey'">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                class="pl-15"
                color="transparent">
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? 'color-default font-weight-bold' : 'color-grey'">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        menu: {
          right: [
            {
              title: 'Profil',
              type: 'profile',
              link: '/profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      }
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.menu.left = this.$store.state.menu
    },
    methods: {
      async toMenu (item) {
        if (item.type === 'logout') {
          await post('admin/auth/logout', {
            data: {
              username: this.user.username
            }
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              TokenService.removeToken()
              
              window.location = '/'
            }
          })
        } else {
          this.$router.push('/profile')
        }
      }
    }
  }
</script>